import { Form, Checkbox } from "antd";
import type { CheckboxProps } from 'antd';

interface CheckboxFieldProps extends CheckboxProps {
    name: string;
    checked?: boolean;
}

const CheckboxField = (props: CheckboxFieldProps) => {
    return (
        <Form.Item
            name={props.name}
            colon={false}
            style={{ textAlign: "left" }}
        >
            <Checkbox
                className="checkbox"
                id={props.name}
                style={{ paddingTop: "10px" }}
                onChange={props.onChange}
                checked={props.checked}
            >
                {props.value}
            </Checkbox>
        </Form.Item>
    );
};

export default CheckboxField;